import { getCwdHashForFileIndex } from './paths.js';
import type { Database } from 'node-sqlite3-wasm';

export function upsertFileIndexParentPath(db: Database, resolved: string): number {
  const now = new Date().toISOString();
  db.run(
    `INSERT INTO file_index_parent_path (path, path_hash, updated_at)
     VALUES (?, ?, ?)
     ON CONFLICT(path) DO UPDATE SET path_hash = excluded.path_hash, updated_at = excluded.updated_at`,
    [resolved, getCwdHashForFileIndex(resolved), now],
  );
  const row = db.get('SELECT id FROM file_index_parent_path WHERE path = ?', [resolved]) as
    | { id: number | bigint }
    | null;
  if (row == null) throw new Error(`Failed to upsert file index parent path: ${resolved}`);
  return Number(row.id);
}
